import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import pick from "lodash/pick";
import isArray from "lodash/isArray";
import { Modal, Button } from "components/bootstrap";
import useHotkeysContext from "hooks/useHotkeysContext";
import SectionGrid from "components/common/Section/SectionGrid";
import HotkeyCollectionSection from "components/hotkeys/HotkeyCollectionSection";
import { Link } from "components/common";
import Routes from "routing/Routes";
const Content = styled.div`
  padding: 20px;
`;
const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ModalHotkeyCollectionSection = ({ collection, scope }) => {
  const { activeHotkeys } = useHotkeysContext();
  const { title, description, actions } = collection;
  const filtratedActions = useMemo(
    () => Object.entries(actions).filter(([actionKey]) => {
      const key = `${scope}.${actionKey}`;
      return activeHotkeys.has(key) && activeHotkeys.get(key).options.displayInOverview !== false;
    }).map(([actionKey, { description: keyDescription, keys, displayKeys }]) => {
      var _a, _b, _c, _d, _e, _f;
      const isEnabled = !!((_b = (_a = activeHotkeys.get(`${scope}.${actionKey}`)) == null ? void 0 : _a.options) == null ? void 0 : _b.enabled);
      const splitKey = (_d = (_c = activeHotkeys.get(`${scope}.${actionKey}`)) == null ? void 0 : _c.options) == null ? void 0 : _d.splitKey;
      const combinationKey = (_f = (_e = activeHotkeys.get(`${scope}.${actionKey}`)) == null ? void 0 : _e.options) == null ? void 0 : _f.combinationKey;
      const reactKey = isArray(keys) ? keys.join(",") : keys;
      return {
        isEnabled,
        splitKey,
        combinationKey,
        reactKey,
        keyDescription,
        keys: displayKeys != null ? displayKeys : keys
      };
    }),
    [actions, activeHotkeys, scope]
  );
  if (!filtratedActions.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(HotkeyCollectionSection, { sectionActions: filtratedActions, description, title });
};
const useEnabledCollections = () => {
  const { hotKeysCollections, enabledScopes } = useHotkeysContext();
  const allScopesEnabled = enabledScopes.length === 1 && enabledScopes[0] === "*";
  const collection = allScopesEnabled ? hotKeysCollections : pick(hotKeysCollections, enabledScopes);
  return Object.entries(collection);
};
const HotkeysModal = ({ onToggle }) => {
  const { t } = useTranslation("common");
  const enabledCollection = useEnabledCollections();
  return /* @__PURE__ */ React.createElement(Modal, { onHide: onToggle, show: true, bsSize: "large" }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, t("hotkeys.title"))), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(SectionGrid, null, enabledCollection.map(([scope, collection]) => /* @__PURE__ */ React.createElement(ModalHotkeyCollectionSection, { scope, collection, key: scope }))))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(Footer, null, /* @__PURE__ */ React.createElement(Link, { to: Routes.KEYBOARD_SHORTCUTS, target: "_blank" }, t("hotkeys.view_all")), /* @__PURE__ */ React.createElement(Button, { onClick: () => onToggle() }, t("actions.close")))));
};
export default HotkeysModal;
